var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("mortgage-calculators-toolbar", {
                attrs: { "is-loading": _vm.isLoading },
                on: {
                  "clear-selection": _vm.handleClearSelection,
                  "run-report": _vm.runReport,
                  "set-default": _vm.compPay,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("b-row", [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("financial-tools.payment_analyzer_description")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      1. " +
                  _vm._s(_vm.$t("financial-tools.mortgage_amount")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t(
                      "financial-tools.mortgage_amount_description"
                    ),
                    expression:
                      "\n          $t('financial-tools.mortgage_amount_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "mortgageAmount",
                  placeholder: "0",
                  "class-name": "fe-num-field dollar",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.mortgage_amount").toString(),
                  "show-tooltip-message": true,
                  max: "100000000",
                  "max-length": 14,
                  "error-message": _vm.errorMessageAmt,
                },
                model: {
                  value: _vm.indata.mortgageAmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "mortgageAmount", $$v)
                  },
                  expression: "indata.mortgageAmount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      2. " +
                  _vm._s(_vm.$t("financial-tools.interest_rate")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t("financial-tools.interest_rate_description"),
                    expression:
                      "\n          $t('financial-tools.interest_rate_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  placeholder: "0",
                  "class-name": "fe-num-field decimal-input",
                  decimals: 3,
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.interest_rate").toString(),
                  max: "100",
                  "max-length": 6,
                  "show-tooltip-message": true,
                  "error-message": _vm.errorMessageRate,
                },
                model: {
                  value: _vm.indata.interestRate,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "interestRate", $$v)
                  },
                  expression: "indata.interestRate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _vm._v(
                "\n      3. " +
                  _vm._s(_vm.$t("financial-tools.amortization_period")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t(
                      "financial-tools.amortization_period_description"
                    ),
                    expression:
                      "\n          $t('financial-tools.amortization_period_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "amortizPeriod",
                  placeholder: "0",
                  "class-name": "fe-num-field calculated",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.interest_rate").toString(),
                  "show-tooltip-message": true,
                  max: "35",
                  "max-length": 2,
                  "error-message": _vm.errorMessagePer,
                },
                model: {
                  value: _vm.indata.amortizPeriod,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "amortizPeriod", $$v)
                  },
                  expression: "indata.amortizPeriod",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        _vm._l(
          [
            "financial-tools.frequency",
            "financial-tools.monthly",
            "financial-tools.semi_monthly",
            "financial-tools.bi_weekly",
            "financial-tools.bi_weekly_accel",
            "financial-tools.weekly",
            "financial-tools.weekly_accel",
          ],
          function (labela) {
            return _c("b-col", { key: labela, staticClass: "mb-3" }, [
              _vm._v("\n      " + _vm._s(_vm.$t(labela)) + "\n    "),
            ])
          }
        ),
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("financial-tools.payment")) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatMoney(_vm.pay.Month)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatMoney(_vm.pay.semiMonth)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatMoney(_vm.pay.BiWeek)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatMoney(_vm.pay.AccelBi)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatMoney(_vm.pay.Week)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatMoney(_vm.pay.AccelWeek)) + "\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("financial-tools.amortization")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatVal(_vm.amortiz.Month)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.formatVal(_vm.amortiz.semiMonth)) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatVal(_vm.amortiz.BiWeek)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatVal(_vm.amortiz.AccelBi)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.formatVal(_vm.amortiz.Week)) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.formatVal(_vm.amortiz.AccelWeek)) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row", { staticClass: "m-3" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("financial-tools.DHdisclaimer")) + "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }